import React from "react";

export function Home(): JSX.Element {
  return <div>Deze pagina zou je niet moeten kunnen zien..</div>;
}
